import { ConsultationResource } from '@aorg/models/resources/Consultation/ConsultationResource';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { Consultation } from '../models/consultation';
import type { RootState } from '../store';

const initialState: Consultation = {
  list: [],
  selected: null,
  expertList: [],
  expertSelected: null,
};

const setup = createSlice({
  name: 'consultation',
  initialState,
  reducers: {
    setConsultationList(
      state,
      { payload }: PayloadAction<ConsultationResource[]>
    ) {
      return { ...state, list: payload };
    },
    setConsultationSelected(
      state,
      { payload }: PayloadAction<ConsultationResource | null>
    ) {
      return { ...state, selected: payload };
    },
    setConsultationClear(state) {
      return {
        ...initialState,
        expertList: state.expertList,
        expertSelected: state.expertSelected,
      };
    },
    setExpertConsultationList(
      state,
      { payload }: PayloadAction<ConsultationResource[]>
    ) {
      return { ...state, expertList: payload };
    },
    setExpertConsultationSelected(
      state,
      { payload }: PayloadAction<ConsultationResource | null>
    ) {
      return { ...state, expertSelected: payload };
    },
    setExpertConsultationClear(state) {
      return { ...initialState, list: state.list, selected: state.selected };
    },
    setConsultationsClearAll(state) {
      return initialState;
    },
  },
});

export const {
  setConsultationList,
  setConsultationSelected,
  setConsultationClear,
  setExpertConsultationList,
  setExpertConsultationSelected,
  setExpertConsultationClear,
  setConsultationsClearAll,
} = setup.actions;

export const selectConsultationList = ({ consultation }: RootState) =>
  consultation.list;
export const selectConsultationSelected = ({ consultation }: RootState) =>
  consultation.selected;
export const selectExpertConsultationList = ({ consultation }: RootState) =>
  consultation.expertList;
export const selectExpertConsultationSelected = ({ consultation }: RootState) =>
  consultation.expertSelected;

export default setup.reducer;
